// extracted by mini-css-extract-plugin
export default {"featuredIcons":"Featured_featuredIcons__g7JGf","featured":"Featured_featured__A8QJu"};